import React from 'react';

/** A Material Design icon - the same set the mobile app uses (@mdi/js paths). */
export function MdiIcon({ path, className }: { path: string; className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className ?? 'h-5 w-5'} aria-hidden="true" fill="currentColor">
      <path d={path} />
    </svg>
  );
}
